import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { css } from '@emotion/react';
import {
  Headline1,
  Headline4,
  ParagraphM,
  ParagraphS,
} from '../../core/Typography/Typography';

export const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.light_grey};
`;

export const Inner = styled.div`
  ${defaultContainerSize};
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${mq.medium(css`
    padding-left: 3rem;
    padding-right: 3rem;
  `)};

  ${mq.large(css`
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  `)};

  ${mq.xLarge(css`
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  `)};
`;

export const Title = styled.h1`
  ${Headline1};
  font-size: 2rem;
  letter-spacing: -0.013rem;
  color: ${({ theme }) => theme.colors.core_black};
  margin: 4rem 0 2rem 0;

  ${mq.medium(css`
    font-size: 3rem;
    margin: 5rem 0 2rem 0;
  `)};

  ${mq.xLarge(css`
    font-size: 3rem;
    margin: 5rem 0 2.5rem 0;
  `)};
`;

export const DescriptionText = styled.p`
  ${ParagraphS};
  letter-spacing: 0.013rem;
  color: ${({ theme }) => theme.colors.core_black};
  max-width: 29.375rem;
  padding: 0;
  margin: 0;
`;

export const IconsWrapper = styled.div`
  display: grid;
  column-gap: 1.125rem;
  row-gap: 1.125rem;
  grid-template-columns: repeat(4, 3.2rem);
  margin: 4.125rem 0 5rem 0;
  justify-content: center;

  ${mq.xSmall(css`
    column-gap: 1.5rem;
    row-gap: 1.5rem;
  `)};

  ${mq.mSmall(css`
    column-gap: 2.125rem;
    row-gap: 2.125rem;
  `)};

  ${mq.smallIp(css`
    grid-template-columns: repeat(4, 4.2rem);
  `)};

  ${mq.medium(css`
    justify-content: unset;
    margin: 4.575rem 0 5.575rem 0;
    column-gap: 1.9rem;
    row-gap: 1.9rem;
    grid-template-columns: repeat(4, 5.5rem);
  `)};

  ${mq.xLarge(css`
    column-gap: 3.438rem;
    row-gap: 1.875rem;
    grid-template-columns: repeat(4, 6.5rem);
    margin: 6rem 0 7.5rem 0;
  `)};
`;

export const Icon = styled.div`
  width: 3.375rem;

  ${mq.smallIp(css`
    width: 4.2rem;
  `)};

  ${mq.medium(css`
    width: 5.668rem;
  `)};

  ${mq.xLarge(css`
    width: 7.5rem;
  `)};
`;

export const Tags = styled.div`
  ${ParagraphS};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 24.5rem;
  margin-top: 1.25rem;
  letter-spacing: 0.013rem;
  text-align: left;
  color: ${({ theme }) => theme.colors.core_black};
`;

export const Footer = styled.div`
  ${defaultContainerSize};
  padding-top: 0.5rem;
  padding-bottom: 5rem;

  ${mq.medium(css`
    padding-top: 3.5rem;
    padding-bottom: 7.5rem;
  `)};
`;

export const FooterTitle = styled.p`
  ${Headline4};
  letter-spacing: 0;
  margin-bottom: 0;
  text-align: left;
`;

export const FooterValues = styled.div`
  padding-top: 2.5rem;
  display: flex;
  flex-direction: column;

  ${mq.xLarge(css`
    flex-direction: row;
    justify-content: space-between;
  `)};
`;

export const FooterValuesValue = styled.div`
  max-width: 14.375rem;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:not(:first-child) {
    margin-top: 1.5rem;
  }

  ${mq.xLarge(css`
    &:not(:first-child) {
      margin-top: 0;
    }
  `)};
`;

export const FooterValuesValueImage = styled.div`
  width: 4rem !important;
  height: 4rem !important;
`;

export const FooterValuesValueText = styled.div`
  ${ParagraphM};
  padding-left: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.75rem;
  letter-spacing: 0;
  text-align: left;
  color: ${({ theme }) => theme.colors.darker_grey};
  font-family: ${({ theme }) => theme.font.questrial};
`;
